import type { ComponentDefinition } from '@wix/platform-editor-sdk';

import {
  shouldUseLoginSocialBarV2,
  shouldUseScalableDimensionsForLoginBarOnBuilderEditor,
} from '../../../../utils/experiments';
import { resolveBuilderLoginBarComponentRef } from './builder-editor-login-bar-component-ref';
import { COMMON_LOGIN_COMP_CONNECTIONS_V2 } from './common-login-bar-layouts';
import { LOGIN_COMP_RESPONSIVE_APP_WIDGET } from './responsive-login-bar-layouts';

const getLoginBarBuilderEditorCompDef = async () => {
  const [useScalableDimensions, useLoginSocialBarV2] = await Promise.all([
    shouldUseScalableDimensionsForLoginBarOnBuilderEditor(),
    shouldUseLoginSocialBarV2(),
  ]);

  const loginBarWidth = 110;

  return {
    componentType: resolveBuilderLoginBarComponentRef(useLoginSocialBarV2),
    layout: {
      width: loginBarWidth,
      height: 40,
      x: 740,
      y: 24,
    },
    connections: COMMON_LOGIN_COMP_CONNECTIONS_V2,
    layoutResponsive: {
      type: 'LayoutData',
      componentLayouts: [
        {
          type: 'ComponentLayout',
          ...(useScalableDimensions
            ? {
                width: { type: 'spx', value: loginBarWidth },
                height: { type: 'spx', value: 40 },
              }
            : {
                width: { type: 'px', value: loginBarWidth },
                height: { type: 'px', value: 40 },
                minHeight: { type: 'px', value: 40 },
              }),
        },
      ],
      itemLayouts: LOGIN_COMP_RESPONSIVE_APP_WIDGET.layoutResponsive.itemLayouts,
      containerLayouts: [],
    },
  } as unknown as ComponentDefinition;
};

export { getLoginBarBuilderEditorCompDef };
